exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".object-radio-button[data-v-4ae3e5e0] {\n  transform: scale(1.5);\n}\n.object-radio-button:checked~.object-radio-button-label[data-v-4ae3e5e0]::before {\n  color: #fff;\n  border-color: #7b1fa2;\n}\n.object-radio-button:checked~.object-radio-button-label[data-v-4ae3e5e0]::before {\n  background-color: green;\n}\n", ""]);

// exports
